type HandleRecommenderQueryUpdateProps<Query> = {
  prevResult: Query;
  fetchMoreResult?: Query;
  recommenderKey: string;
};

export const handleRecommenderQueryUpdate = <Query = unknown>({
  prevResult,
  fetchMoreResult,
  recommenderKey,
}: HandleRecommenderQueryUpdateProps<Query>): Query => {
  if (!fetchMoreResult) {
    return prevResult;
  }
  const prevData = prevResult[recommenderKey];
  const fetchMoreData = fetchMoreResult[recommenderKey];
  return {
    [recommenderKey]: {
      ...prevData,
      ...fetchMoreData,
      products: [
        ...prevData.products,
        ...fetchMoreData.products.filter(
          (product) =>
            !prevData.products
              .map((recommendation) => recommendation.id)
              .includes(product.id)
        ),
      ],
    },
  } as Query;
};
